<template>
  <v-dialog
    v-model="dialog"
    :width="dialogWidth"
    transition="fade-transition"
    :scrollable="true"
  >
    <v-form v-model="formValid" @submit="save">
      <v-card>
        <v-card-title class="headline">{{
          $t("createTeamDialog.title")
        }}</v-card-title>
        <v-card-text>
          <div class="pb-2">
            <span>{{ $t("createTeamDialog.description") }}</span>
          </div>
          <v-autocomplete
            v-if="$appDataset.tenant === 'bfv'"
            label="Verein"
            v-model="name"
            :items="clubs"
            item-text="name"
            item-value="id"
          ></v-autocomplete>
          <v-text-field
            v-else
            data-test-id="createTeamDialog-name"
            v-model="name"
            :disabled="loading"
            autocomplete="off"
            :label="$t('createTeamDialog.team-name')"
          ></v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn type="submit" :loading="loading" class="primary">
            <v-icon left>mdi-content-save</v-icon>{{ $t("common.save") }}
          </v-btn>
          <v-btn :disabled="loading" class="secondary" @click="close()">
            <v-icon left>mdi-close</v-icon>{{ $t("common.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { MUTATION_RAISE_NOTIFICATION } from "@/plugins/store.js";

export default {
  name: "CreateTeamDialog",
  mixins: [],
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
    successAction: {
      type: Function,
      required: false,
    },
    game: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      loading: false,
      dialog: false,
      name: undefined,
      formValid: true,
      clubs: [],
    };
  },
  watch: {
    visible: function (val) {
      this.dialog = val;
    },
    dialog: function (val) {
      if (val === false) {
        this.closeAction();
      }
    },
  },
  computed: {
    dialogWidth: function () {
      if (this.$vuetify.breakpoint.smAndUp) {
        return "700";
      }
      return "90%";
    },
  },
  mounted() {
    this.dialog = this.visible;
    this.loadClubs()
  },
  methods: {
    loadClubs(){
      this.loading = true
      this.$api
        .loadClubs()
        .then(res => {
          this.loading = false
          this.clubs = res.data
        })
        .catch(err => {
          this.loading = false;
          this.$common.onError(err);
        })
    },
    save(e) {
      e.preventDefault();
      this.loading = true;
      let name = this.name
      if(this.$appDataset.tenant === 'bfv'){
        name = this.clubs.filter(c => c.id === this.name)[0].name
      }
      this.$api
        .createGameInstanceTeam(this.game.uid, { name: name, clubId: this.$appDataset.tenant === 'bfv' ? this.name : null})
        .then(res => {
          this.loading = false;
          let msg = this.$t("createTeamDialog.success", {team: name});
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: "success",
            message: msg,
          });
          this.successAction && this.successAction(res);
          this.reset();
          this.close();
        })
        .catch((error) => {
          this.loading = false;
          this.$common.onError(error);
        });
    },
    reset() {
      this.name = undefined;
    },
    close() {
      this.$emit("input", null);
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
</style>
